import { render, staticRenderFns } from "./ContentTemplateAccount.vue?vue&type=template&id=0eba12b4"
import script from "./ContentTemplateAccount.vue?vue&type=script&lang=js"
export * from "./ContentTemplateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports